import {btoa} from 'abab'
import {Suspense} from 'react'
import {graphql, useLazyLoadQuery} from 'react-relay/hooks'
import {Outlet, useParams} from 'react-router-dom'

import {Box} from '@chakra-ui/react'

import {
  LoadingPage,
  PageNavigation,
  PageNavigationGroup,
  PageNavigationItem,
} from 'components'
import {SiteLayout} from 'pages/site/components'

import {UserFollowButton} from '../components/UserFollowButton'

import {UserProfileRootQuery} from './__generated__/UserProfileRootQuery.graphql'
import {Header} from './components/Header'

export function UserProfileRoot() {
  const {userId} = useParams()
  const {user} = useLazyLoadQuery<UserProfileRootQuery>(
    graphql`
      query UserProfileRootQuery($userId: ID!) {
        user(id: $userId) {
          ...Header_user
          ...UserFollowButton_user
          resourcePath
          followerPrivacy
          viewerCanFollow
          followers(first: 1) {
            pageInfo {
              total
            }
          }
          following(first: 1) {
            pageInfo {
              total
            }
          }
        }
      }
    `,
    {
      userId: btoa(`User:${userId}`),
    }
  )

  return (
    <SiteLayout>
      <Header user={user} />

      <PageNavigation>
        <PageNavigationGroup>
          <PageNavigationItem end to={user.resourcePath}>
            Activity
          </PageNavigationItem>
          <PageNavigationItem to="favorites">
            Favorites ({user.following.pageInfo.total})
          </PageNavigationItem>
          <PageNavigationItem to="fans">
            Fans ({user.followers.pageInfo.total})
          </PageNavigationItem>
        </PageNavigationGroup>

        {user.viewerCanFollow && !user.followerPrivacy && (
          <PageNavigationGroup pr={2}>
            <UserFollowButton user={user} />
          </PageNavigationGroup>
        )}
      </PageNavigation>

      <Box p={4}>
        <Suspense fallback={<LoadingPage />}>
          <Outlet />
        </Suspense>
      </Box>
    </SiteLayout>
  )
}
